export default "__VITE_ASSET__CaD5OCKM__"